<section class="login">
  <div class="container-fluid">
    <div class="row no-padding">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div class="login-content">
          <div class="logo">
            <img src="/assets/images/logo.png" alt="EDP - Distribuição" />
          </div>
          <div class="registration">
            <h1 color="gray">Acesso negado</h1>
            <br />
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</section>
